"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuPosition = void 0;

function getMenuPosition(element, position) {
  if (!element) {
    return {
      top: 0,
      left: 0
    };
  }

  const rect = element.getBoundingClientRect();
  const top = position === 'bottom' ? rect.y + rect.height : rect.y;
  const left = position === 'left' ? rect.x : rect.x + rect.width;
  return {
    top: top + window.scrollY,
    left: left + window.scrollX
  };
}

exports.getMenuPosition = getMenuPosition;